/* MURE — reveal animácie a galéria.
   Animácie sú len vylepšenie: bez JS sa všetko zobrazí v konečnom stave. */
(function () {
  document.documentElement.classList.add('js');

  function reveal() {
    var els = document.querySelectorAll('[data-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.25 });
    els.forEach(function (el) { io.observe(el); });
  }

  reveal();
  // Shopify prekresľuje sekcie v theme editore
  document.addEventListener('shopify:section:load', reveal);
})();